export const CONVERSATION_TYPE = {
  DIRECT: 1,
  GROUP: 2
};

export const MESSAGE_TYPE = {
  TEXT: 1
};

export const SENDER_ROLE = {
  RESIDENT: 1,
  BUILDING_MANAGER: 2,
  ORG_ADMIN: 3,
  SUPER_ADMIN: 99
};

export const SEARCH_DEBOUNCE_MS = 400;
export const CHAT_MESSAGES_PAGE_SIZE = 50;
export const CHAT_CONVERSATIONS_PAGE_SIZE = 20;

export const CHAT_EVENT_MESSAGE_NEW = 'message.new';
